<div class="grid-row grid-gap-1">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <label class="usa-legend usa-legend--medium">
      HHG Template Download
    </label>
    </div>
</div>

<form [formGroup]="hhgTemplateForm">
    <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="message">
            <div class="usa-alert usa-alert--info usa-alert--no-icon">
                <div class="usa-alert__body">
                    <p class="usa-alert__text">
                        {{message}}
                    </p>
                </div>
            </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4" *ngIf="isRsfp">
            <label class="usa-label" for="tsp_list">Select TSP<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
            <select id="tsp_list" class="maxw-full usa-select" formControlName="tspList" (change)="tspChange()">
        <option [ngValue]="0" selected disabled>Choose...</option>
        <option *ngFor="let tsp of rsfpCarrierList" [ngValue]="tsp">{{tsp.scac}}
      </select>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="rate_type" class="usa-label">Rate Type<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
            <select id="rate_type" class="maxw-full usa-select" formControlName="rateType" (change)="rateTypeChange()">
        <option [ngValue]="0" selected disabled>Choose...</option>
        <option *ngFor="let rate of rateTypes" [ngValue]="rate">{{rate.legacyRateType}} - {{rate.description}}
      </select>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="agency_id" class="usa-label">SRO ID <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
            <select id="agency_id" class="usa-select maxw-full" formControlName="sroType" (change)="sroIdChange()">
        <option [ngValue]="'null'">All</option>
        <option *ngFor="let sro of sroTypeList" [value]="sro.sroMasterId">{{sro.sroId}}
        </option>
      </select>
        </div>
    </div>

    <div class="grid-row grid-gap-1 padding-top-4">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <button type="button" class="usa-button" [disabled]="hhgTemplateForm.invalid" (click)="getHhgFile()">Download Template</button>
        </div>
    </div>
</form>
